module.exports = __webpack_public_path__ + "static/media/orkids.d3e50e35.pdf";